import {Injectable} from '@angular/core';
import {HeizcheckBackendService} from "./backend.service";
import {Router} from "@angular/router";
import {PortalService} from "../../services/portal.service";
import {HeizcheckAnfrage} from "../anfrage/heizcheck.anfrage";
import {HeizkostenabrechnungForm} from "../heizkostenabrechnung/heizkostenabrechnung.form";
import {EnergyMapService} from "../../energy-map/services/energy.map.service";
import {RequestService} from "../../services/request.service";
import {RequestAnfrage} from "../../model/request.anfrage";
import {EmbedService} from "../../services/embed.service";

/**
 * global advisordata that can be injected by the backend
 * @var object
 */
declare let advisorObjectData;

/**
 * Service for saving the request data locally in the browser to have it on all steps.
 */
@Injectable({
  providedIn: 'root'
})
export class HeizcheckRequestService extends RequestService {

  /**
   * name of the id if it comes from the request.
   */
  public static readonly PARAM_NAME_REQUESTID = 'id';

  /**
   * @inheritdoc
   */
  requestObjectName = 'hec-anfrage';

  /**
   * List of fields we want to ignore that come from the backend.
   */
  ignoreBackendFields: string[] = ['gebaeude_heizkosten_gesamt', 'wohnung_heizkosten_gesamt'];

  /**
   * Holds the users input object
   * @private
   */
  protected anfrage: HeizcheckAnfrage;

  /**
   * constructor.
   */
  constructor(public backendService: HeizcheckBackendService, protected router: Router, protected portalService: PortalService,
              protected energyMapService: EnergyMapService, protected embedService: EmbedService) {

    super(backendService, portalService, embedService);
    try {
      if (typeof advisorObjectData === "object" && typeof localStorage === "object") {
        // check if result object exists and save it as verbrauchsanalyseResult
        if (advisorObjectData.verbrauchsanalyseResult?.result) {
          advisorObjectData.verbrauchsanalyseResult = advisorObjectData.verbrauchsanalyseResult.result;
        }
        // save injected data
        localStorage.setItem(this.requestObjectName, JSON.stringify(advisorObjectData));
        // if we preset the data, redirect to result step
        if (advisorObjectData?.verbrauchsanalyseInput?.nutzungstyp === 'mieter' ||
          advisorObjectData?.verbrauchsanalyseInput?.nutzungstyp === 'wohnungseigentuemer') {
          // path to result heizkostenabrechnung
          this.router.navigate([this.portalService.currentPortalId + '/heizcheck/auswerten/heizkostenabrechnung']);
        }
        else if (advisorObjectData?.verbrauchsanalyseInput?.nutzungstyp === 'hauseigentuemer' ||
          advisorObjectData?.verbrauchsanalyseInput?.nutzungstyp === 'hausverwalter') {
          // path to result verbrauchsanalyse
          this.router.navigate([this.portalService.currentPortalId + '/heizcheck/ergebnis/verbrauchsanalyse']);
        }
      }
    } catch (e) {

    }

    this.loadDataFromLocalStorage();
  }

  /**
   * @inheritdoc
   */
  getNewAnfrage(): RequestAnfrage {
    return new HeizcheckAnfrage();
  }

  /**
   * @inheritdoc
   */
  getAnfrage(): HeizcheckAnfrage {
    return super.getAnfrage() as HeizcheckAnfrage;
  }

  /**
   * Removes some fields from the resultliste because we do not have this field or the value is empty or not known (in case of optionfields)
   * @param result
   */
  public clearResult(result: any): void {
    const formConfig = new HeizkostenabrechnungForm(this.energyMapService);

    for(const page of Object.keys(result.fields)) {
      for(const field of Object.keys(result.fields[page])) {
        const fieldObject = formConfig.getField(field);
        if(!fieldObject) {
          // case 1: field not found in form, remove it
          delete result.fields[page][field];
        }
        else if(this.ignoreBackendFields.indexOf(field) !== -1) {
          // some fields are ignored because they are calculated later
          delete result.fields[page][field];
        }
        else {
          // some special checks on some field types
          if((fieldObject.type === 'textselect' && fieldObject.fieldData.secondId === field) ||
            fieldObject.type === 'radio' || fieldObject.type === 'select') {
            if(fieldObject.getOptions().indexOf(result.fields[page][field].value) === -1) {
              // case 2: Field has option but the value that was found, ist not in the optionlist
              delete result.fields[page][field];
            }
          }
          else if(typeof result.fields[page][field].value === "string" && result.fields[page][field].value.trim().length === 0) {
            // case 3: The detected value is empty
            delete result.fields[page][field];
          }
        }
      }
    }
  }
}
